export class ViewManager {
    constructor(app) {
        this.app = app;
        this.contentVisible = true;
        this.toggleCreated = false;
        this.currentWindow = null;
    }

    createToggleSwitch(targetWindow) {
        // Create toggle container
        this.toggleContainer = document.createElement('label');
        this.toggleContainer.className = 'view-toggle';
        
        // Create checkbox input
        this.toggleInput = document.createElement('input');
        this.toggleInput.type = 'checkbox';
        this.toggleInput.checked = true;
        
        // Create slider
        this.slider = document.createElement('span');
        this.slider.className = 'slider';
        
        // Assemble toggle
        this.toggleContainer.appendChild(this.toggleInput);
        this.toggleContainer.appendChild(this.slider);
        
        // Add event listener
        this.toggleInput.addEventListener('change', () => this.toggleContent());
        
        // Hide toggle by default
        this.toggleContainer.style.display = 'none';
        
        // Store current window reference
        this.currentWindow = targetWindow;
        
        return this.toggleContainer;
    }

    toggleContent() {
        if (!this.currentWindow) return;
        
        this.contentVisible = this.toggleInput.checked;
        
        if (this.contentVisible) {
            this.currentWindow.classList.add('visible');
        } else {
            this.currentWindow.classList.remove('visible');
        }
    }

    showToggle() {
        this.toggleContainer.style.display = 'inline-block';
        this.toggleInput.checked = true;
        this.contentVisible = true;
    }

    hideToggle() {
        // Check if toggle elements exist before trying to access them
        if (this.toggleContainer && this.toggleInput) {
            this.toggleContainer.style.display = 'none';
            // Reset state when hiding
            this.contentVisible = true;
            this.toggleInput.checked = true;
        }
    }
}
